import React, { useCallback, useEffect, useState } from "react";

import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';


export default function Expense_details() {


  const today = new Date().toISOString().split("T")[0];

  const [expense_name, setexpense_name] = useState('');
  const [expense_details, setexpense_details] = useState('');
  const [date, setdate] = useState(today);
  const [amount, setamount] = useState('');
  const [description, setdescription] = useState('');
  
  // Validation states
  const [errors, setErrors] = useState({
    expense_name: "",
    expense_details: "",
    date: "",
    amount: "",
    description: "",
  });
  const [touched, setTouched] = useState({
    expense_name: false,
    expense_details: false,
    date: false,
    amount: false,
    description: false,
  });
  const [submitAttempted, setSubmitAttempted] = useState(false);
  
  const apiUrl = Config.apiUrl;

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  // Validation functions
  const validateExpenseName = (value) => {
    if (!value || value.trim() === "") {
      return "Expense name is required";
    }
    if (value.trim().length < 2) {
      return "Expense name must be at least 2 characters";
    }
    if (value.trim().length > 100) {
      return "Expense name must not exceed 100 characters";
    }
    // Allow letters, spaces, and common characters
    if (!/^[a-zA-Z0-9\s\.\-']+$/.test(value.trim())) {
      return "Expense name can only contain letters, numbers, spaces, dots, hyphens, and apostrophes";
    }
    return "";
  };

  const validateExpenseDetails = (value) => {
    if (!value || value.trim() === "") {
      return "Expense details is required";
    }
    if (value.trim().length < 2) {
      return "Expense details must be at least 2 characters";
    }
    if (value.trim().length > 100) {
      return "Expense details must not exceed 100 characters";
    }
    return "";
  };

  const validateDate = (value) => {
    if (!value || value.trim() === "") {
      return "Date is required";
    }
    const selectedDate = new Date(value);
    selectedDate.setHours(0, 0, 0, 0);
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    // Allow today's date and past dates, but not future dates
    if (selectedDate > todayDate) {
      return "Date cannot be in the future";
    }
    return "";
  };

  const validateAmount = (value) => {
    if (!value || value.trim() === "") {
      return "Amount is required";
    }
    // Remove commas and spaces for validation
    const cleanValue = value.replace(/[,\s]/g, '');
    if (!/^\d+(\.\d{1,2})?$/.test(cleanValue)) {
      return "Amount must be a valid number (e.g., 1000 or 1000.50)";
    }
    const numValue = parseFloat(cleanValue);
    if (numValue <= 0) {
      return "Amount must be greater than 0";
    }
    if (numValue > 999999999) {
      return "Amount is too large";
    }
    return "";
  };

  const validateDescription = (value) => {
    if (value && value.trim().length > 0) {
      if (value.trim().length < 5) {
        return "Description must be at least 5 characters if provided";
      }
      if (value.trim().length > 500) {
        return "Description must not exceed 500 characters";
      }
    }
    return "";
  };

  // Validate all fields
  const validateAll = () => {
    const newErrors = {
      expense_name: validateExpenseName(expense_name),
      expense_details: validateExpenseDetails(expense_details),
      date: validateDate(date),
      amount: validateAmount(amount),
      description: validateDescription(description),
    };
    setErrors(newErrors);
    return !newErrors.expense_name && !newErrors.expense_details && !newErrors.date && !newErrors.amount && !newErrors.description;
  };

  const [isDataChanged, setIsDataChanged] = useState(false);
  const navigate = useNavigate();

  // ..............................< Unsaved Navigation>...............................
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDataChanged) {
        const message = "You have unsaved changes. Are you sure you want to leave?";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDataChanged]);

  // Callback function to handle navigation from the header
  const handleHeaderNavigation = () => {
    if (isDataChanged && !window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
      // If there are unsaved changes and the user clicks cancel, prevent navigation
      return false;
    }
    return true; // Allow navigation
  };


  // ...........................<Cancle Model>.......................

  const cancelModel = () => {
    if (isDataChanged) {
      const confirmCancel = window.confirm('You have unsaved changes. Are you sure you want to cancel?');
      if (!confirmCancel) {
        return;
      }
    }

    setexpense_name('');
    setexpense_details('');
    setdate(today);
    setamount('');
    setdescription('');
    setErrors({
      expense_name: "",
      expense_details: "",
      date: "",
      amount: "",
      description: "",
    });
    setTouched({
      expense_name: false,
      expense_details: false,
      date: false,
      amount: false,
      description: false,
    });
    setSubmitAttempted(false);
    setIsDataChanged(false);

    // Use the navigate function to redirect to another page
    // replace '/your-redirect-path' with the desired path
  };

  const handleExpenseNameChange = (e) => {
    const value = capitalizeWords(e.target.value);
    setexpense_name(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.expense_name || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        expense_name: validateExpenseName(value),
      }));
    }
  };

  const handleExpenseNameBlur = () => {
    setTouched((prev) => ({ ...prev, expense_name: true }));
    setErrors((prev) => ({
      ...prev,
      expense_name: validateExpenseName(expense_name),
    }));
  };

  const handleExpenseDetailsChange = (e) => {
    const value = capitalizeWords(e.target.value);
    setexpense_details(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.expense_details || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        expense_details: validateExpenseDetails(value),
      }));
    }
  };

  const handleExpenseDetailsBlur = () => {
    setTouched((prev) => ({ ...prev, expense_details: true }));
    setErrors((prev) => ({
      ...prev,
      expense_details: validateExpenseDetails(expense_details),
    }));
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setdate(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.date || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        date: validateDate(value),
      }));
    }
  };

  const handleDateBlur = () => {
    setTouched((prev) => ({ ...prev, date: true }));
    setErrors((prev) => ({
      ...prev,
      date: validateDate(date),
    }));
  };

  const handleAmountChange = (e) => {
    let value = e.target.value;
    // Allow only digits, dots, commas, and spaces
    value = value.replace(/[^\d.,\s]/g, '');
    setamount(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.amount || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        amount: validateAmount(value),
      }));
    }
  };

  const handleAmountBlur = () => {
    setTouched((prev) => ({ ...prev, amount: true }));
    setErrors((prev) => ({
      ...prev,
      amount: validateAmount(amount),
    }));
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setdescription(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.description || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        description: validateDescription(value),
      }));
    }
  };

  const handleDescriptionBlur = () => {
    setTouched((prev) => ({ ...prev, description: true }));
    setErrors((prev) => ({
      ...prev,
      description: validateDescription(description),
    }));
  };

  //.........................................[ Add Expense ]...........................................



  const AddExpense = async (e) => {
    e.preventDefault();

    // Mark submit as attempted
    setSubmitAttempted(true);

    // Mark all fields as touched
    setTouched({
      expense_name: true,
      expense_details: true,
      date: true,
      amount: true,
      description: true,
    });

    // Validate all fields
    if (!validateAll()) {
      return;
    }

    // Clean amount - remove commas and spaces
    const cleanAmount = amount.replace(/[,\s]/g, '');

    let item = {
      expense_name: expense_name.trim(),
      expense_details: expense_details.trim(),
      date: date,
      amount: cleanAmount,
      description: description.trim(),
    };
    try {
      let result = await fetch(`${apiUrl}/save_expense`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      if (result.ok) {
        toast.success("Expense added successfully", { autoClose: 1000 });
        setexpense_name("");
        setexpense_details("");
        setdate(today);
        setamount("");
        setdescription("");
        setErrors({
          expense_name: "",
          expense_details: "",
          date: "",
          amount: "",
          description: "",
        });
        setTouched({
          expense_name: false,
          expense_details: false,
          date: false,
          amount: false,
          description: false,
        });
        setSubmitAttempted(false);
        setIsDataChanged(false);

        // Reload the page after successful submission
        setTimeout(() => {
          window.location.reload();
        }, 1500);

      } else {
        toast.error("Failed to add Expense");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to add Expense");
    }
  };





  return (
    <>
      <ToastContainer />
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header onNavigate={handleHeaderNavigation} />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Expense Details</h4>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Add New Expense</h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={AddExpense} noValidate>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-expense-name"
                          >
                            Expense Name <span className="text-danger">*</span>
                          </label>
                          <div className="input-group input-group-merge">
                            <input
                              type="text"
                              id="basic-default-expense-name"
                              className={`form-control ${(touched.expense_name && errors.expense_name) || (submitAttempted && !expense_name.trim()) ? 'is-invalid' : touched.expense_name && !errors.expense_name && expense_name ? 'is-valid' : ''}`}
                              placeholder="Enter Expense Name"
                              aria-label="Expense Name"
                              aria-describedby="expense-name-error"
                              value={expense_name}
                              onChange={handleExpenseNameChange}
                              onBlur={handleExpenseNameBlur}
                            />
                          </div>
                          {((touched.expense_name && errors.expense_name) || (submitAttempted && !expense_name.trim())) && (
                            <div className="invalid-feedback d-block" id="expense-name-error">
                              {errors.expense_name || "Expense name is required"}
                            </div>
                          )}
                          {touched.expense_name && !errors.expense_name && expense_name && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-expense-details"
                          >
                            Expense Details <span className="text-danger">*</span>
                          </label>
                          <div className="input-group input-group-merge">
                            <input
                              type="text"
                              id="basic-default-expense-details"
                              className={`form-control ${(touched.expense_details && errors.expense_details) || (submitAttempted && !expense_details.trim()) ? 'is-invalid' : touched.expense_details && !errors.expense_details && expense_details ? 'is-valid' : ''}`}
                              placeholder="Enter Expense Detail"
                              aria-label="Expense Details"
                              aria-describedby="expense-details-error"
                              value={expense_details}
                              onChange={handleExpenseDetailsChange}
                              onBlur={handleExpenseDetailsBlur}
                            />
                          </div>
                          {((touched.expense_details && errors.expense_details) || (submitAttempted && !expense_details.trim())) && (
                            <div className="invalid-feedback d-block" id="expense-details-error">
                              {errors.expense_details || "Expense details is required"}
                            </div>
                          )}
                          {touched.expense_details && !errors.expense_details && expense_details && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-date"
                          >
                            Date <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            className={`form-control ${(touched.date && errors.date) || (submitAttempted && !date.trim()) ? 'is-invalid' : touched.date && !errors.date && date ? 'is-valid' : ''}`}
                            id="basic-default-date"
                            placeholder="Enter date"
                            value={date}
                            onChange={handleDateChange}
                            onBlur={handleDateBlur}
                            max={today}
                          />
                          {((touched.date && errors.date) || (submitAttempted && !date.trim())) && (
                            <div className="invalid-feedback d-block">
                              {errors.date || "Date is required"}
                            </div>
                          )}
                          {touched.date && !errors.date && date && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-amount"
                          >
                            Amount <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${(touched.amount && errors.amount) || (submitAttempted && !amount.trim()) ? 'is-invalid' : touched.amount && !errors.amount && amount ? 'is-valid' : ''}`}
                            id="basic-default-amount"
                            placeholder="Enter Amount"
                            value={amount}
                            onChange={handleAmountChange}
                            onBlur={handleAmountBlur}
                          />
                          {((touched.amount && errors.amount) || (submitAttempted && !amount.trim())) && (
                            <div className="invalid-feedback d-block">
                              {errors.amount || "Amount is required"}
                            </div>
                          )}
                          {touched.amount && !errors.amount && amount && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                          <small className="text-muted">
                            Enter amount (e.g., 1000 or 1000.50)
                          </small>
                        </div>

                        {/* <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-phone"
                          >
                            Opening Stock
                          </label>
                          <input
                            type="number"
                            id="basic-default-phone"
                            className="form-control phone-mask"
                            placeholder="Enter Opening Stock"
                            value={openingStock}
                            onChange={(e) => setOpeningStock(e.target.value)}
                          />
                        </div> */}
                        <div className="col-md-12 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-description"
                          >
                            Description <small className="text-muted">(Optional)</small>
                          </label>
                          <textarea
                            id="basic-default-description"
                            className={`form-control ${(touched.description && errors.description) ? 'is-invalid' : touched.description && !errors.description && description ? 'is-valid' : ''}`}
                            placeholder="Enter description (optional)"
                            rows={3}
                            value={description}
                            onChange={handleDescriptionChange}
                            onBlur={handleDescriptionBlur}
                            maxLength={500}
                          />
                          {touched.description && errors.description && (
                            <div className="invalid-feedback d-block">
                              {errors.description}
                            </div>
                          )}
                          {touched.description && !errors.description && description && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                          <small className="text-muted">
                            {description.length}/500 characters
                          </small>
                        </div>

                        <div className="col-12">
                          <div className="col-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                            >
                              Submit
                            </button>

                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={cancelModel}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
